import * as Device from "expo-device";

export function isIphone() {
  const isPhone = Device.deviceType === Device.DeviceType.PHONE;
  const isIOS = Device.osName === "iOS";
  return isPhone && isIOS;
}
